import React, { useEffect, useRef, useState } from 'react';
import { auth } from './services/api';
import Login from './components/Login';
import Sources from './components/Sources';
import './App.css';

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [authError, setAuthError] = useState('');
  const [onglet, setOnglet] = useState('accueil');
  // Garde-fou contre le double-échange du code OIDC en StrictMode (même patron
  // que le CRM et que BI).
  const oidcHandled = useRef(false);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);

    // DEV UNIQUEMENT : ?jeton=<jwt> pose le jeton et recharge — permet de
    // prévisualiser sans Entra tant que le redirect localhost n'est pas
    // déclaré. Ce chemin n'existe pas dans le build de production.
    if (process.env.NODE_ENV === 'development' && params.get('jeton')) {
      localStorage.setItem('data-token', params.get('jeton'));
      window.location.replace('/');
      return;
    }

    const retourOidc = window.location.pathname === '/oidc/callback' || params.has('code');
    if (retourOidc && !oidcHandled.current) {
      oidcHandled.current = true;
      traiterRetourOidc(params);
    } else {
      verifierSession();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const verifierSession = async () => {
    if (localStorage.getItem('data-token')) {
      try {
        const res = await auth.getMe();
        setUser(res.data.user);
      } catch (e) {
        localStorage.removeItem('data-token');
      }
    }
    setLoading(false);
  };

  const traiterRetourOidc = async (params) => {
    const nettoyerUrl = () => window.history.replaceState({}, '', '/');
    try {
      const erreurOauth = params.get('error_description') || params.get('error');
      if (erreurOauth) throw new Error(erreurOauth);
      const code = params.get('code');
      const state = params.get('state');
      if (!code || !state) throw new Error('Réponse Microsoft incomplète');
      const res = await auth.microsoftCallback(code, state);
      nettoyerUrl();
      localStorage.setItem('data-token', res.data.token);
      setUser(res.data.user);
    } catch (error) {
      nettoyerUrl();
      setAuthError(error.response?.data?.error || error.message || 'Échec de la connexion Microsoft');
    } finally {
      setLoading(false);
    }
  };

  const seDeconnecter = () => {
    localStorage.removeItem('data-token');
    setUser(null);
  };

  if (loading) return null;
  if (!user) return <Login authError={authError} />;

  return (
    <div className="da-shell">
      <header className="da-header">
        <span className="da-brand">
          A<span className="da-gold">97</span>
          <span className="da-brand-app">Data</span>
        </span>
        <nav className="da-onglets" aria-label="Sections">
          {[['accueil', 'Accueil'], ['reprise', 'Reprise CRM → entrepôt']].map(([code, libelle]) => (
            <button key={code} type="button" className="da-onglet" aria-current={onglet === code ? 'page' : undefined}
              onClick={() => setOnglet(code)}>{libelle}</button>
          ))}
        </nav>
        <div className="da-header-user">
          <BasculeTheme />
          <span>{user.prenom ? `${user.prenom} ${user.nom || ''}`.trim() : user.email}</span>
          <button className="da-logout" onClick={seDeconnecter}>Se déconnecter</button>
        </div>
      </header>
      <main className="da-main">
        <Sources user={user} onglet={onglet} />
      </main>
    </div>
  );
}

// Bascule mode jour / mode nuit (même geste que A97 BI).
function BasculeTheme() {
  const [theme, setTheme] = React.useState(() => document.documentElement.dataset.theme || 'light');
  const nuit = theme === 'dark';
  const basculer = () => {
    const t = nuit ? 'light' : 'dark';
    document.documentElement.dataset.theme = t;
    try { localStorage.setItem('data-theme', t); } catch (e) { /* navigation privée */ }
    setTheme(t);
  };
  return (
    <button type="button" className="da-theme" onClick={basculer}
      title={nuit ? 'Passer en mode jour' : 'Passer en mode nuit'} aria-label={nuit ? 'Passer en mode jour' : 'Passer en mode nuit'}>
      {nuit ? (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><circle cx="12" cy="12" r="4" /><path d="M12 2v2M12 20v2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M2 12h2M20 12h2M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4" /></svg>
      ) : (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 12.8A9 9 0 1 1 11.2 3a7 7 0 0 0 9.8 9.8z" /></svg>
      )}
    </button>
  );
}

export default App;
